import { BootstrapVue, IconsPlugin } from "bootstrap-vue"

import "@/assets/styles/lite-blue.min.css"

export default {
  install(Vue) {
    // Install BootstrapVue
    Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
    Vue.use(IconsPlugin)
    Vue.component("vue-perfect-scrollbar", () =>
      import("vue-perfect-scrollbar")
    )
  }
}
